// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"6b95bfa0","189":"6b95bfa0"}[chunkId] + ".chunk.css";
};